import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IdentityField } from 'components/form/IdentityField';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { Field } from 'react-final-form';
import { DatePickerAdapter } from 'components/form/DatePickerAdapter';
import { MAINTENANCE_TYPE_OPTIONS } from 'constants/maintenanceTypes';

export const MaintenanceMonthDataDialog = ({
  openCalendar,
  onCancel,
  onSubmit
}: {
  openCalendar: boolean;
  onCancel: () => void;
  onSubmit: (values: { date: string; maintenance_type?: number | null }) => void;
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={openCalendar} onClose={onCancel}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DialogTitle>{t('pages.maintenance.add-scheduled-title')}</DialogTitle>
        <DialogContent sx={{ width: '400px' }}>
          <ReactFinalForm onSubmit={onSubmit} formId="addMaintenanceDate" hideControls={true}>
            <div className="w-full flex flex-col gap-3">
              <IdentityField
                name="date"
                component={DatePickerAdapter}
                label={t('global.date')}
                required={true}
              />
              <Field name="maintenance_type">
                {({ input }) => (
                  <TextField
                    select
                    fullWidth
                    label={t('entities.maintenance.maintenance_type')}
                    value={input.value ?? ''}
                    onChange={(e) =>
                      input.onChange(e.target.value === '' ? null : Number(e.target.value))
                    }>
                    <MenuItem value="">{t('entities.maintenance.empty_option')}</MenuItem>
                    {MAINTENANCE_TYPE_OPTIONS.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {t(`entities.maintenance.maintenance_type_options.${option.code}`)}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </Field>
            </div>
          </ReactFinalForm>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="error">
            {t(`actions.cancel`)}
          </Button>
          <Button type="submit" form="addMaintenanceDate">
            {t(`actions.confirm`)}
          </Button>
        </DialogActions>
      </LocalizationProvider>
    </Dialog>
  );
};
